import { VALID_CC } from 'common/regex';
const CLEAN_CC_NUMBER = /[\s-]/g;
const VALID_CVV_LENGTH = /^\d{3,4}$/;

/*
 Luhn Validation Algorithm
 */
export function isValidCreditCardNumber(number: string) {
  let cleanNum = number;
  if (number) {
    cleanNum = number.replace(CLEAN_CC_NUMBER, '');
  }
  const luhnCheck = (function (arr: number[]) {
    return function (ccNum: string) {
      let bit = 1,
        len = ccNum.length,
        sum = 0,
        val;

      while (len) {
        val = parseInt(ccNum.charAt(--len), 10);
        // eslint-disable-next-line no-cond-assign
        sum += (bit ^= 1) ? (arr[val] as number) : val;
      }
      return sum && sum % 10 === 0;
    };
  })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

  return VALID_CC.test(cleanNum) && luhnCheck(cleanNum);
}

export function isValidCVV(cvv: string) {
  if (!cvv) {
    return false;
  }

  if (VALID_CVV_LENGTH.test(cvv)) {
    return true;
  }

  return false;
}

export function isAfterPayOrder(issuingBank: string) {
  return issuingBank?.toLowerCase().includes('afterpay');
}
